import unionWith from 'lodash/unionWith';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { convertUnitToSubUnit, unitDivisor } from '../../util/currency';
import { formatDateStringToTz, getExclusiveEndDateWithTz } from '../../util/dates';
import { parse } from '../../util/urlHelpers';
import config from '../../config';
import { fetchCurrentUser } from '../../ducks/user.duck';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { TRANSITION_ZERO_REQUEST_PAYMENT } from '../../util/transaction';
import { findOptionsForSelectFilter } from '../../util/search';
import moment from 'moment';
import { apiBaseUrl } from '../../util/api';
import axios from 'axios';
import { MIN_WORKER_START_HOUR } from '../../marketplace-custom-config';

// Pagination page size might need to be dynamic on responsive page layouts
// Current design has max 3 columns 12 is divisible by 2 and 3
// So, there's enough cards to fill all columns on full pagination pages
const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );
const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));
const RESULT_PAGE_SIZE = 10;
const commonParams = {
  perPage: RESULT_PAGE_SIZE,
  include: ['author', 'images'],
  'fields.listing': ['title', 'description', 'geolocation', 'price', 'publicData', 'metadata'],
  'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
  'fields.image': ['variants.landscape-crop', 'variants.landscape-crop2x'],
  'limit.images': 1,
};
// ================ Action types ================ //

export const SEARCH_LISTINGS_REQUEST = 'app/SearchPage/SEARCH_LISTINGS_REQUEST';
export const SEARCH_LISTINGS_SUCCESS = 'app/SearchPage/SEARCH_LISTINGS_SUCCESS';
export const SEARCH_LISTINGS_ERROR = 'app/SearchPage/SEARCH_LISTINGS_ERROR';

export const SEARCH_MAP_LISTINGS_REQUEST = 'app/SearchPage/SEARCH_MAP_LISTINGS_REQUEST';
export const SEARCH_MAP_LISTINGS_SUCCESS = 'app/SearchPage/SEARCH_MAP_LISTINGS_SUCCESS';
export const SEARCH_MAP_LISTINGS_ERROR = 'app/SearchPage/SEARCH_MAP_LISTINGS_ERROR';

export const SEARCH_MAP_SET_ACTIVE_LISTING = 'app/SearchPage/SEARCH_MAP_SET_ACTIVE_LISTING';

export const FETCH_APPLIED_JOB_REQUEST = 'app/SearchPage/FETCH_APPLIED_JOB_REQUEST';
export const FETCH_APPLIED_JOB_SUCCESS = 'app/SearchPage/FETCH_APPLIED_JOB_SUCCESS';
export const FETCH_APPLIED_JOB_ERROR = 'app/SearchPage/FETCH_APPLIED_JOB_ERROR';
export const FETCH_UNFAVOURITE_LISTING = 'app/SearchPage/FETCH_UNFAVOURITE_LISTING';

// ================ Reducer ================ //

const initialState = {
  pagination: null,
  searchParams: null,
  searchInProgress: false,
  searchListingsError: null,
  currentPageResultIds: [],
  searchMapListingIds: [],
  searchMapListingsError: null,

  fetchInProgress: false,
  fetchAllWorkersError: null,
  pagination: null,
  currentPageWorkers: [],
  workingStaffs: [],
  workingStaffsRequest: false,
  workingStaffsError: null,
};

const resultIds = data => data?.data?.map(l => l.id);
const resIds = data => data.data.map(l => l?.relationships?.listing?.data?.id);

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_LISTINGS_REQUEST:
      return {
        ...state,
        searchParams: payload.searchParams,
        searchInProgress: true,
        searchMapListingIds: [],
        searchListingsError: null,
        currentPageResultIds: [],
      };
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        searchInProgress: false,
      };
    case SEARCH_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchInProgress: false, searchListingsError: payload };
    case FETCH_UNFAVOURITE_LISTING:
      return {
        ...state,
        currentPageResultIds: state.currentPageResultIds.filter(f => f.uuid !== payload),
        // pagination: payload.data.meta,
        // searchInProgress: false,
      };
    case SEARCH_MAP_LISTINGS_REQUEST:
      return {
        ...state,
        searchMapListingsError: null,
      };
    case SEARCH_MAP_LISTINGS_SUCCESS: {
      const searchMapListingIds = unionWith(
        state.searchMapListingIds,
        resultIds(payload.data),
        (id1, id2) => id1.uuid === id2.uuid
      );
      return {
        ...state,
        searchMapListingIds,
      };
    }
    case SEARCH_MAP_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchMapListingsError: payload };

    case SEARCH_MAP_SET_ACTIVE_LISTING:
      return {
        ...state,
        activeListingId: payload,
      };
    case FETCH_APPLIED_JOB_REQUEST:
      return {
        ...state,
        searchParams: payload.searchParams,
        searchInProgress: true,
        searchMapListingIds: [],
        searchListingsError: null,
        currentPageResultIds: [],
      };
    case FETCH_APPLIED_JOB_SUCCESS:
      const transactions = sortedTransactions(payload.data.data);
      // console.log(12452, transactions, payload.data);
      return {
        ...state,
        // currentPageResultIds: resIds(payload.data),

        workingStaffsRequest: false,
        workingStaffs: entityRefs(transactions),
        pagination: payload.data.meta,
        searchInProgress: false,
      };
    case FETCH_APPLIED_JOB_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, workingStaffsRequest: false, fetchAllWorkersError: payload };
    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const searchListingsRequest = searchParams => ({
  type: SEARCH_LISTINGS_REQUEST,
  payload: { searchParams },
});

export const searchListingsSuccess = response => ({
  type: SEARCH_LISTINGS_SUCCESS,
  payload: { data: response.data },
});

export const searchListingsError = e => ({
  type: SEARCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const fetchAppliedJobShiftsRequest = searchParams => ({
  type: FETCH_APPLIED_JOB_REQUEST,
  payload: { searchParams },
});
export const fetchAppliedJobShiftsSuccess = response => {
  return {
    type: FETCH_APPLIED_JOB_SUCCESS,
    payload: response,
  };
};
export const fetchAppliedJobShiftsError = e => ({
  type: FETCH_APPLIED_JOB_ERROR,
  error: true,
  payload: e,
});

export const fetchUnFavouriteListing = res => ({
  type: FETCH_UNFAVOURITE_LISTING,
  payload: res,
});
export const searchMapListingsRequest = () => ({ type: SEARCH_MAP_LISTINGS_REQUEST });

export const searchMapListingsSuccess = response => ({
  type: SEARCH_MAP_LISTINGS_SUCCESS,
  payload: { data: response.data },
});

export const searchMapListingsError = e => ({
  type: SEARCH_MAP_LISTINGS_ERROR,
  error: true,
  payload: e,
});
const getCurrentWorkerAssignedGigs = async workerId => {
  const url = `${apiBaseUrl()}/api/user/getAcceptableGigs`;
  const resp = await axios.post(url, { workerId });
  return resp.data;
};
export const searchListings = searchParams => async (dispatch, getState, sdk) => {
  const { tab, page = 1, filter, origin, ...rest } = searchParams;
  dispatch(searchListingsRequest(searchParams));

  const originMaybe = config.sortSearchByDistance && origin ? { origin } : {};
  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;

  const favouritesId = fetchedcurrentUser?.attributes?.profile?.protectedData?.favourites || [];
  const assignedGigs =
    tab === 'JobOffers' ? await getCurrentWorkerAssignedGigs(fetchedcurrentUser?.id?.uuid) : [];
  const assignedGigIds = assignedGigs?.length > 0 ? assignedGigs.map(g => g.listingId) : [];
  const jobCategoryOptions = findOptionsForSelectFilter('category', config.custom.filters);
  const appliedListingId =
    fetchedcurrentUser?.attributes?.profile?.publicData?.appliedListingId || [];
  // const filteredUserJobCategory = fetchedcurrentUser?.attributes?.profile?.publicData?.jobCategories?.filter(
  //   c => c.isVerified === true
  // );
  // const userJobCategory = filteredUserJobCategory.map(m => m.category);
  const userJobCategory = fetchedcurrentUser?.attributes?.profile?.publicData?.jobCategories?.map(
    c => c.category
  );

  const sp =
    tab === 'BestMatches'
      ? userJobCategory?.includes(searchParams?.pub_searchJobcategory) ||
        typeof searchParams?.pub_searchJobcategory === 'undefined'
        ? {
            pub_searchJobcategory: `has_any:${userJobCategory}`,

            // pub_keyword: `has_any:${userJobCategory}`,
            page,
            ...rest,
            ...originMaybe,
            ...commonParams,
          }
        : {
            // pub_searchJobcategory: `has_any:${userJobCategory}`,

            // pub_keyword: `has_any:${userJobCategory}`,
            page,
            ...rest,
            ids: [],
            ...originMaybe,
            ...commonParams,
          }
      : tab === 'MostRecent'
      ? {
          ...rest,
          ...originMaybe,
          page,
          ...commonParams,
        }
      : tab === 'SavedJobs'
      ? {
          ...rest,
          ...originMaybe,
          ids: favouritesId,
          page,
          ...commonParams,
        }
      : tab === 'AppliedJob'
      ? {
          ...rest,
          ...originMaybe,
          page,
          // ids: appliedListingId,
          ...commonParams,
        }
      : tab === 'AppliedTab'
      ? {
          ...rest,
          ...originMaybe,
          page,
          ids: appliedListingId,
          sort: '-createdAt',
          ...commonParams,
        }
      : tab === 'JobOffers'
      ? {
          ...rest,
          ...originMaybe,
          page,
          ids: assignedGigIds,
          ...commonParams,
        }
      : null;
  const priceSearchParams = priceParam => {
    const inSubunits = value =>
      convertUnitToSubUnit(value, unitDivisor(config.currencyConfig.currency));
    const values = priceParam ? priceParam.split(',') : [];
    return priceParam && values.length === 2
      ? {
          price: [inSubunits(values[0]), inSubunits(values[1]) + 1].join(','),
        }
      : {};
  };

  const availabilityParams = (datesParam, minDurationParam) => {
    const dateValues = datesParam ? datesParam.split(',') : [];
    const hasDateValues = datesParam && dateValues.length === 2;
    const startDate = hasDateValues ? dateValues[0] : null;
    const endDate = hasDateValues ? dateValues[1] : null;

    const minDurationMaybe =
      minDurationParam && Number.isInteger(minDurationParam) && hasDateValues
        ? { minDuration: minDurationParam }
        : {};

    // Find configs for 'dates-length' filter
    // (type: BookingDateRangeLengthFilter)
    const filterConfigs = config.custom.filters;
    const idOfBookingDateRangeLengthFilter = 'dates-length';
    const dateLengthFilterConfig = filterConfigs.find(
      f => f.id === idOfBookingDateRangeLengthFilter
    );
    // Extract time zone
    const timeZone = dateLengthFilterConfig.config.searchTimeZone;

    return hasDateValues
      ? {
          start: formatDateStringToTz(startDate, timeZone),
          end: getExclusiveEndDateWithTz(endDate, timeZone),

          // When we have `time-partial` value in the availability, the
          // API returns listings that don't necessarily have the full
          // start->end range available, but enough that the minDuration
          // (in minutes) can be fulfilled.
          //
          // See: https://www.sharetribe.com/api-reference/marketplace.html#availability-filtering
          availability: 'time-partial',

          ...minDurationMaybe,
        }
      : {};
  };

  const { perPage, price, dates, minDuration } = searchParams;
  const priceMaybe = priceSearchParams(price);
  const availabilityMaybe = availabilityParams(dates, minDuration);
  const minWorkStartHour = MIN_WORKER_START_HOUR;
  const userOffset = moment().utcOffset();
  const currentDate = Math.round(
    moment
      .utc()
      .add(minWorkStartHour, 'hour')
      .add(userOffset, 'm')
      .valueOf() / 1000
  );

  const params = {
    ...sp,
    ...priceMaybe,
    ...availabilityMaybe,
    pub_isChatWithAdminListing: false,
    per_page: 10,
    ...searchParams,
    pub_gigStartDateInNumberFormat: `${currentDate},`,
  };
  return sdk.listings
    .query(params)
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(searchListingsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(searchListingsError(storableError(e)));
      throw e;
    });
};

export const setActiveListing = listingId => ({
  type: SEARCH_MAP_SET_ACTIVE_LISTING,
  payload: listingId,
});

export const searchMapListings = searchParams => (dispatch, getState, sdk) => {
  dispatch(searchMapListingsRequest(searchParams));

  const { perPage, ...rest } = searchParams;
  const params = {
    ...rest,
    per_page: perPage,
    pub_isChatWithAdminListing: false,
  };

  return sdk.listings
    .query(params)
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(searchMapListingsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(searchMapListingsError(storableError(e)));
      throw e;
    });
};

export const fetchAppliedJobShifts = param => async (dispatch, getState, sdk) => {
  const { page = 1, tab } = param;
  dispatch(fetchAppliedJobShiftsRequest(param));
  // dispatch(searchListingsRequest(param));

  return sdk.transactions
    .query({
      lastTransitions: [TRANSITION_ZERO_REQUEST_PAYMENT],

      only: 'order',
      include: [
        'provider',
        'provider.profileImage',
        'customer',
        'customer.profileImage',
        'booking',
        'listing',
      ],
      'fields.transaction': [
        'lastTransition',
        'lastTransitionedAt',
        'transitions',
        'payinTotal',
        'payoutTotal',
      ],

      'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'profile.publicData'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
      page,
      per_page: RESULT_PAGE_SIZE,
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      // // const payload = { data: finalData, meta: response.data.meta };
      dispatch(fetchAppliedJobShiftsSuccess(response));
      // dispatch(searchListingsSuccess(response));

      return response;
    })
    .catch(e => {
      fetchAppliedJobShiftsError(e);
      // searchListingsError(e);
    });
};

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });

  const { page = 1, address, origin, tab, ...rest } = queryParams;
  // if (tab === 'AppliedTab') {
  //   return dispatch(fetchAppliedJobShifts(queryParams));
  // }
  return dispatch(searchListings(queryParams));
};
